import { render, staticRenderFns } from "./ProfileAvatarEdit.vue?vue&type=template&id=13fc40e8&"
import script from "./ProfileAvatarEdit.vue?vue&type=script&lang=js&"
export * from "./ProfileAvatarEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13fc40e8')) {
      api.createRecord('13fc40e8', component.options)
    } else {
      api.reload('13fc40e8', component.options)
    }
    module.hot.accept("./ProfileAvatarEdit.vue?vue&type=template&id=13fc40e8&", function () {
      api.rerender('13fc40e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProfileAvatarEdit.vue"
export default component.exports